/* eslint-disable react-hooks/exhaustive-deps */
import { Card, CardContent, withStyles, withTheme } from '@material-ui/core';
import { Box, Typography, List, ListItem, ListItemText } from '@mui/material';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getAllClientComments } from '../../clients.actions';
import { formatDate } from '../commentsAndNotes/commentsAndNotes.component';
import { Link } from 'react-router-dom';

const styles = (theme) => ({
  commentItem: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  noComments: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
});

const RecentCommentsCard = props => {
  const { classes, clientId, clientComments } = props;

  useEffect(() => {
    if (clientId) {
      props.getAllClientComments(clientId);
    }
  }, [clientId]);

  // Get the 3 most recent comments
  const recentComments = clientComments
    ? [...clientComments]
        .map(c => c.info || c) // Extract info property if it exists
        .sort((a, b) => new Date(b.addedOn || b.createdDate || 0) - new Date(a.addedOn || a.createdDate || 0))
        .slice(0, 3)
    : [];

  return (
    <Card>
      <CardContent>
        <Box sx={{ display: 'flex', flexDirection: 'row', marginBottom: '16px' }}>
          <FontAwesomeIcon icon={['fas', 'comment']} size="2x" />
          <Typography variant="h5" sx={{ paddingLeft: '20px', fontSize: '1.3125rem', fontWeight: 'bold' }}>
            Recent Comments
          </Typography>
        </Box>
        {recentComments.length > 0 ? (
          <List>
            {recentComments.map((comment, index) => (
              <ListItem key={comment.clientCommentId || comment.commentId || index} className={classes.commentItem} alignItems="flex-start">
                <ListItemText
                  primary={
                    <Box>
                      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                        {comment.subject || 'No Subject'}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        {formatDate(comment.addedOn || comment.createdDate)}
                      </Typography>
                    </Box>
                  }
                  secondary={
                    <Typography variant="body2" sx={{ mt: 0.5 }}>
                      {comment.comment ? 
                        (comment.comment.length > 100 
                          ? `${comment.comment.substring(0, 100)}...` 
                          : comment.comment)
                        : 'No content'}
                    </Typography>
                  }
                />
              </ListItem>
            ))}
            <Box sx={{ paddingTop: '10px'}}>
              <Typography variant="subtitle2" sx={{ a: { color: '#36939B' } }}>
                <Link to={`/clients/${clientId}/comments`}>See All Comments</Link>
              </Typography>
            </Box>
          </List>
        ) : (
          <Typography className={classes.noComments}>
            No comments available
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

RecentCommentsCard.propTypes = {
  classes: PropTypes.object.isRequired,
  clientId: PropTypes.number.isRequired,
  clientComments: PropTypes.array,
  getAllClientComments: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const clientId = state.clients.currentClientId;
  const clientComments = state.clients.clientsInfo[clientId]?.clientDetails?.clientComments || [];
  
  return {
    clientComments,
  };
};

export default compose(
  withStyles(styles),
  withTheme,
  connect(mapStateToProps, {
    getAllClientComments,
  }),
)(RecentCommentsCard);
